import React from "react";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormProvider, useForm } from "react-hook-form";
import { HeadConsult } from "./Head";
//import { PlanningMovable } from "./Steps/Planning/movable";
import { Schedule } from "./Steps/Schedule";
import { PlanningFixed } from "./Steps/Planning/fixed";
import { ProcedurePerformedFixed } from "./Steps/ProceduresPerformed/fixed";
import { ClinicalRecord } from "./Steps/ClinicalRecord";
import { useMaintenance } from "shared/providers/Maintenance";
import { ProcedurePerformedMovable } from "./Steps/ProceduresPerformed/movable";
import { PlanningMovable } from "./Steps/Planning/movable";
import QuestionModal from "components/Modal";
import { useAuth } from "shared/providers/auth";
import { ProcedurePerformedInvisible } from "./Steps/ProceduresPerformed/invisible";
import { PlanningInvisible } from "./Steps/Planning/invisible";

import imageBirthday from "shared/assets/img/aniversario.png";
import { Box, Modal } from "@mui/material";

interface IForm {
  diagnosis: string;
  surgeryNotAlign: boolean;
  treatmentSurgery: boolean;
  complementTreatment: string[];
  bracesType: string[];
}

const ConsultSchema = yup.object().shape({
  diagnosis: yup.string().required(),
  surgeryNotAlign: yup.boolean().required(),
  treatmentSurgery: yup.boolean().required(),
  complementTreatment: yup.array().required(),
  bracesType: yup.array().required(),
});

const MaintenanceStepper: React.FC = () => {
  const { step, patientObj } = useMaintenance();
  const {
    modalOpen,
    alerts,
    setModalOpen,
    openCloseAniversario,
    setOpenCloseAniversario,
  } = useAuth();

  const methods = useForm<IForm>({
    resolver: yupResolver(ConsultSchema),
    mode: "onBlur",
    reValidateMode: "onChange",
  });

  const { handleSubmit } = methods;

  const onSubmit = async (values: IForm) => {
    console.log(values);
  };

  const stepTitle = [
    {
      title: "[start] de [end] - Procedimentos Realizados",
      max: 4,
      step: 1,
      firstPass: 1,
    },
    {
      title: "[start] de [end] - Planejamento da Próxima Consulta",
      max: 4,
      step: 2,
      firstPass: 2,
    },
    { title: "[start] de [end] - Agendamento", max: 4, step: 3, firstPass: 3 },
    {
      title: "[start] de [end] - Ficha Clínica",
      max: 4,
      step: 4,
      firstPass: 4,
    },
  ];

  const handleCloseModal = (
    responses: { id: string; description: string }[]
  ) => {
    //console.log(responses); // Aqui você pode salvar ou enviar as respostas conforme necessário
    setModalOpen(false);
  };

  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <HeadConsult title={stepTitle}>
            {modalOpen && (
              <QuestionModal
                questions={alerts.map((alert) => ({
                  key: alert.key, // Passa a chave do alerta
                  message: alert.message, // Passa a mensagem do alerta
                }))}
                onClose={handleCloseModal}
              />
            )}

            <Modal
              open={openCloseAniversario}
              onClose={() => setOpenCloseAniversario(false)}
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <img src={imageBirthday} alt="birthday" width={550} />
              </Box>
            </Modal>

            {step === 1 ? (
              patientObj && patientObj.type && patientObj.type === 2 ? (
                <ProcedurePerformedMovable />
              ) : patientObj && patientObj.type && patientObj.type === 3 ? (
                <ProcedurePerformedInvisible />
              ) : (
                <ProcedurePerformedFixed />
              )
            ) : (
              ""
            )}
            {step === 2 ? (
              patientObj && patientObj.type && patientObj.type === 2 ? (
                <PlanningMovable />
              ) : patientObj && patientObj.type && patientObj.type === 3 ? (
                <PlanningInvisible />
              ) : (
                <PlanningFixed />
              )
            ) : (
              ""
            )}
            {step === 3 && <Schedule />}
            {step === 4 && <ClinicalRecord />}
          </HeadConsult>
        </form>
      </FormProvider>
    </>
  );
};

export { MaintenanceStepper };
